export default __webpack_public_path__ + "static/media/instagram.060786e4.svg";